
import './App.css';
import Props from './componentes/ejerciciosProps/Props';
import Navbar from './componentes/ejerciciosProps/Navbar/Navbar';
import WheaterPanel from './componentes/ejerciciosProps/WheaterPanel/WheaterPanel';
function App() {
  return (
    <div>
      <Navbar/>
      <WheaterPanel/>
    </div>
)}

export default App;
